import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "action-bar-light" }
const _hoisted_2 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_3 = { class: "flex items-end justify-center min-h-full p-4 sm:items-center sm:p-0" }
const _hoisted_4 = {
  key: 0,
  class: "min-h-full px-4 py-16 bg-white sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full" }
const _hoisted_7 = { class: "mt-3 sm:mt-5" }
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3" }

import {Ref, ref} from "vue";
import {FlagIcon} from '@heroicons/vue/20/solid';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {store} from "@/store";
import {client, trackEvent} from '@/shared';
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import {FlagContent} from "@/dtos";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlagContent',
  props: {
    url: {},
    metadata: {}
  },
  setup(__props: any) {

const props = __props;

let reasons = [
    'Spam',
    'Incorrect information',
    'Contains nudity, explicit content or violent imagery',
    'Violates privacy standards',
    'I posted this content and want to delete it'
];
let responseStatus = ref({});
let flagSuccessful: Ref<Boolean> = ref(false);

let request = ref(new FlagContent({
    url: props.url,
    reason: '',
    details: '',
    metadata: props.metadata
}));

let isOpen = ref(false);
const closeConfirmation = async () => {
    isOpen.value = false;
}
const flag = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    isOpen.value = true;
};

const isSubmitting = ref(false);
const report = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    isSubmitting.value = true;
    await client.post<ResponseStatus>(new FlagContent(request.value))
        .then(_ => {
            trackEvent( 'content_flagged', request.value);
            flagSuccessful.value = true;
            responseStatus.value = {};
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
        });

    isSubmitting.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        "aria-label": "Flag Content",
        class: "relative inline-flex items-center gap-2 px-3 py-2 mx-auto mb-8 text-xs bg-white rounded-sm focus:z-10",
        href: "#",
        onClick: _withModifiers(flag, ["prevent"])
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          fill: "currentColor",
          class: "w-4 h-4 shrink-0 opacity-80 text-inherit",
          viewBox: "0 0 448 512"
        }, [
          _createElementVNode("path", {
            class: "fa-secondary",
            opacity: ".4",
            d: "M64 352L433 213.6c9-3.4 15-12 15-21.6s-6-18.2-15-21.6L64 32V352z"
          }),
          _createElementVNode("path", {
            class: "fa-primary",
            d: "M32 0C49.7 0 64 14.3 64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z"
          })
        ], -1),
        _createTextVNode(" Flag Content ")
      ]))
    ]),
    _createVNode(_unref(TransitionRoot), {
      show: _unref(isOpen),
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: closeConfirmation
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(DialogPanel), { class: "relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", { class: "absolute top-0 right-0 hidden pt-4 pr-4 sm:block" }, [
                      _createElementVNode("button", {
                        class: "text-gray-400 bg-white rounded-md hover:text-gray-600 focus:outline-hidden",
                        type: "button",
                        onClick: closeConfirmation
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("span", { class: "sr-only" }, "Close", -1),
                        _createElementVNode("svg", {
                          class: "w-6 h-6",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            d: "M6 18L18 6M6 6l12 12",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ], -1)
                      ]))
                    ]),
                    (_unref(flagSuccessful))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[5] || (_cache[5] = [
                          _createElementVNode("div", { class: "min-w-full mx-auto text-center" }, [
                            _createElementVNode("div", { class: "space-y-3" }, [
                              _createElementVNode("h1", { class: "text-3xl font-bold tracking-tight text-gray-900 md:text-4xl" }, "Thank you!"),
                              _createElementVNode("p", { class: "my-4 text-xl leading-6 text-clay-800" }, "We have received your report.")
                            ])
                          ], -1)
                        ])))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(FlagIcon), {
                              "aria-hidden": "true",
                              class: "w-6 h-6 text-red-600"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg font-medium leading-6 text-center text-gray-900"
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode(" Flag this item ")
                              ])),
                              _: 1
                            }),
                            _createVNode(ErrorSummary, {
                              "response-status": _unref(responseStatus),
                              class: "mt-2"
                            }, null, 8, ["response-status"]),
                            _createElementVNode("div", _hoisted_8, [
                              _cache[7] || (_cache[7] = _createElementVNode("label", {
                                class: "block text-sm font-medium text-gray-700",
                                for: "location"
                              }, "Reason for reporting", -1)),
                              _withDirectives(_createElementVNode("select", {
                                id: "reason",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(request).reason) = $event)),
                                class: "block w-full py-2 pl-3 pr-10 mt-1 text-base border rounded-md border-clay-500 focus:border-slate-700 focus:outline-hidden focus:ring-slate-700 sm:text-sm",
                                name: "reason"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reasons), (r) => {
                                  return (_openBlock(), _createElementBlock("option", { key: r }, _toDisplayString(r), 1))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _unref(request).reason]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _cache[8] || (_cache[8] = _createElementVNode("label", {
                                class: "block text-sm font-medium text-gray-700",
                                for: "details"
                              }, "Please provide specific details below", -1)),
                              _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("textarea", {
                                  id: "details",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(request).details) = $event)),
                                  class: "block w-full border rounded-md shadow-sm border-clay-500 focus:border-slate-700 focus:ring-slate-700 sm:text-sm",
                                  name: "details",
                                  rows: "4"
                                }, null, 512), [
                                  [_vModelText, _unref(request).details]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                              class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border rounded-md shadow-sm border-clay-500 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-slate-700 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm",
                              type: "button",
                              onClick: _withModifiers(closeConfirmation, ["prevent"])
                            }, " Cancel "),
                            _createVNode(SaButton, {
                              onClick: _withModifiers(report, ["prevent"]),
                              loading: isSubmitting.value,
                              variant: "primary"
                            }, {
                              loading: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("span", { class: "font-semibold" }, "Reporting...", -1)
                              ])),
                              default: _withCtx(() => [
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-semibold" }, "Report", -1))
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ])
                        ]))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})